/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ChangePasswordRequestDTO
 */
export interface ChangePasswordRequestDTO {
    /**
     * 
     * @type {string}
     * @memberof ChangePasswordRequestDTO
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof ChangePasswordRequestDTO
     */
    oldPassword?: string;
    /**
     * 
     * @type {string}
     * @memberof ChangePasswordRequestDTO
     */
    password?: string;
}

export function ChangePasswordRequestDTOFromJSON(json: any): ChangePasswordRequestDTO {
    return ChangePasswordRequestDTOFromJSONTyped(json, false);
}

export function ChangePasswordRequestDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChangePasswordRequestDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'email': !exists(json, 'email') ? undefined : json['email'],
        'oldPassword': !exists(json, 'oldPassword') ? undefined : json['oldPassword'],
        'password': !exists(json, 'password') ? undefined : json['password'],
    };
}

export function ChangePasswordRequestDTOToJSON(value?: ChangePasswordRequestDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'email': value.email,
        'oldPassword': value.oldPassword,
        'password': value.password,
    };
}

